/**
 * Indicates whether to use mocked addresses or Google Places Autocomplete.
 */
export const USE_MOCKED_ADDRESSES = false;
